import { render, staticRenderFns } from "./LessonWordSeo.vue?vue&type=template&id=4ec8ccff&"
import script from "./LessonWordSeo.vue?vue&type=script&lang=js&"
export * from "./LessonWordSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports